import { render, staticRenderFns } from "./PenSolid.vue?vue&type=template&id=19e8d4d0&"
import script from "./PenSolid.vue?vue&type=script&lang=ts&"
export * from "./PenSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports